import { render, staticRenderFns } from "./NewRegistrationDocuments.vue?vue&type=template&id=0e9617c8&"
import script from "./NewRegistrationDocuments.vue?vue&type=script&lang=js&"
export * from "./NewRegistrationDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports